import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    // Close modal with ESC key
    this.boundHandleEscape = this.handleEscape.bind(this)
    document.addEventListener("keydown", this.boundHandleEscape)
  }

  disconnect() {
    document.removeEventListener("keydown", this.boundHandleEscape)
  }

  open() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden" // Prevent background scrolling
  }

  close() {
    this.modalTarget.classList.add("hidden")
    document.body.style.overflow = "" // Restore scrolling
    
    // Reset form if exists
    const form = this.modalTarget.querySelector("form")
    if (form) {
      form.reset()
    }
  }

  preventClose(event) {
    event.stopPropagation()
  }

  handleEscape(event) {
    if (event.key === "Escape" && !this.modalTarget.classList.contains("hidden")) {
      this.close()
    }
  }
}
